// resetUserIsFollowingDebounceIds.js
'use strict';
import { SET_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Reset user is following debounce ids
 * @kind action
 * @return {Promise} Action promise.
 */
const resetUserIsFollowingDebounceIds = () => async dispatch => {
  return dispatch({
    type: SET_OPERATION_DATA,
    payload: {
      selectPath: ['debouncedUserIsFollowing'],
      data: {
        userIds: [],
      },
    },
  });
};

export default resetUserIsFollowingDebounceIds;
